module.exports = __webpack_public_path__ + "static/media/angry-red.772030fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/nagatrons/angry-red.png
// module id = 185
// module chunks = 0